module.exports = __webpack_public_path__ + "img/perm.e983b06d.png";